import { NavLink, Link } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const navItems = [
  { label: "Painel Geral", path: "/" },
  { label: "Visão Geral", path: "/nc-geral" },
  { label: "Acertos", path: "/acertos" },
  { label: "Trocas", path: "/trocas" },
  { label: "Faltas de Circulação", path: "/faltas" },
  { label: "Ações de Melhoria", path: "/melhorias" },
];

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { logout } = useAuth();

  return (
    <header
      data-testid="main-header"
      className="bg-[#017cb7] text-white sticky top-0 z-50 shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            data-testid="header-logo"
            className="flex items-center gap-3 shrink-0"
          >
            <img
              id="logoimg"
              src="https://play-lh.googleusercontent.com/iSreCpNE1K9TS5sBX07r6JRtFUVrMrpjbVNlnKavmYJu2cXcKbkoMsc_1uay4yoEQ3M"
              alt="TUB"
              className="h-12 w-auto object-contain"
            />
            <span className="hidden sm:inline-block h-5 w-px bg-white/30" />
            <span className="hidden sm:block text-white/80 text-sm font-light">
              Não Conformidades
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav
            data-testid="desktop-nav"
            className="hidden md:flex items-center gap-1"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                data-testid={`nav-${item.path.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium tracking-wide transition-colors duration-200 ${
                    isActive
                      ? "bg-[#01a7f4] text-white"
                      : "text-white/80 hover:text-white hover:bg-white/10"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={logout}
              title="Terminar sessão"
              className="hidden md:flex items-center gap-1.5 px-3 py-2 rounded-md text-sm text-white/80 hover:text-white hover:bg-white/10 transition-colors"
            >
              <LogOut size={15} />
              Sair
            </button>

            {/* Mobile Menu Toggle */}
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2 rounded-md hover:bg-white/10 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Nav */}
        {mobileOpen && (
          <nav
            data-testid="mobile-nav"
            className="md:hidden pb-4 border-t border-white/20 pt-3 space-y-1"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                data-testid={`mobile-nav-${item.path.replace("/", "") || "home"}`}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `block px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-[#01a7f4] text-white"
                      : "text-white/80 hover:text-white hover:bg-white/10"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
